import * as Yup from 'yup';

export const changeRolSchema = Yup.object().shape({
  rol: Yup.string().required(),
});
